import type { SVGProps } from "react";
export interface ArcheryArrowIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function ArcheryArrowIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: ArcheryArrowIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M.875 12C.875 5.857 5.856.876 12.001.876q.356 0 .707.022l.696.066.114.02a1.125 1.125 0 0 1-.28 2.221l-.115-.009-.557-.052a8.876 8.876 0 1 0 8.291 8.293l-.051-.556-.01-.114a1.125 1.125 0 0 1 2.222-.28l.02.113.064.695q.023.351.023.707c0 6.143-4.98 11.123-11.124 11.124C5.856 23.125.875 18.145.875 12m16.655-.965c.621.018 1.11.536 1.092 1.157l-.018.333a6.625 6.625 0 1 1-6.797-7.147 1.126 1.126 0 0 1 .065 2.248 4.376 4.376 0 1 0 4.501 4.502l.009-.114a1.126 1.126 0 0 1 1.148-.979"
      />
      <path
        fill={color}
        d="M19.18.89c.357.058.665.284.826.608l.832 1.662 1.664.834a1.126 1.126 0 0 1 .293 1.801l-3 3c-.21.211-.497.33-.795.33h-2.534l-2.63 2.628c.178.199.289.46.289.747 0 .583-.443 1.062-1.01 1.12l-.115.005h-1.5a1.125 1.125 0 0 1-1.125-1.125V11c0-.621.504-1.125 1.125-1.125.287 0 .547.11.746.287l2.629-2.628V5c0-.298.119-.584.33-.795l3-3 .1-.09c.246-.193.563-.276.875-.225m-2.055 4.576v1.409h1.41L20.1 5.308l-.603-.302a1.13 1.13 0 0 1-.503-.503l-.303-.605z"
      />
    </svg>
  );
}
